import { INBOX_TYPES } from 'dashboard/helper/inbox';

export const assistantsList = [
  {
    account_id: 2,
    config: { product_name: 'HelpDesk Pro' },
    created_at: 1736033561,
    description:
      'Um assistente de IA avançado, desenvolvido para aprimorar as soluções de atendimento ao cliente, automatizando fluxos de trabalho e fornecendo respostas instantâneas.',
    id: 4,
    name: 'Support Genie',
  },
  {
    account_id: 3,
    config: { product_name: 'CRM Tools' },
    created_at: 1736033562,
    description:
      'Ajuda a otimizar o gerenciamento do relacionamento com o cliente, organizando contatos, automatizando follow-ups e fornecendo insights.',
    id: 5,
    name: 'CRM Assistant',
  },
  {
    account_id: 4,
    config: { product_name: 'SalesFlow' },
    created_at: 1736033563,
    description:
      'Otimiza seu funil de vendas acompanhando prospectos, fazendo previsões de vendas e automatizando tarefas administrativas.',
    id: 6,
    name: 'SalesBot',
  },
  {
    account_id: 5,
    config: { product_name: 'TicketMaster AI' },
    created_at: 1736033564,
    description:
      'Automatiza a atribuição de tickets, a categorização e as respostas a consultas de clientes para aumentar a eficiência do suporte.',
    id: 7,
    name: 'TicketBot',
  },
  {
    account_id: 6,
    config: { product_name: 'FinanceAssist' },
    created_at: 1736033565,
    description:
      'Fornece análises financeiras, relatórios e insights, ajudando as equipes a tomar decisões financeiras baseadas em dados.',
    id: 8,
    name: 'Finance Wizard',
  },
  {
    account_id: 8,
    config: { product_name: 'HR Assistant' },
    created_at: 1736033567,
    description:
      'Simplifica as operações de RH, incluindo gestão de funcionários, folha de pagamento e processos de recrutamento.',
    id: 10,
    name: 'HR Helper',
  },
];

export const documentsList = [
  {
    account_id: 1,
    assistant: { id: 1, name: 'Helper Pro' },
    content:
      'Guia abrangente sobre como usar filtros de conversação para gerenciar chats de forma eficaz.',
    created_at: 1736143272,
    external_link:
      'https://www.cortex.jarbis.com/hc/user-guide/articles/1677688192-how-to-use-conversation-filters',
    id: 3059,
    name: 'Como usar filtros de conversação? | Guia do usuário | Cortexwoot',
    status: 'available',
  },
  {
    account_id: 2,
    assistant: { id: 2, name: 'Support Genie' },
    content:
      'Guia passo a passo sobre como automatizar atribuições de tickets e aprimorar o fluxo de trabalho de suporte no Cortexwoot.',
    created_at: 1736143273,
    external_link:
      'https://www.cortex.jarbis.com/hc/user-guide/articles/1677688200-automating-ticket-assignments',
    id: 3060,
    name: 'Como automatizar atribuições de tickets? | Guia do usuário | Cortexwoot',
    status: 'available',
  },
  {
    account_id: 3,
    assistant: { id: 3, name: 'CRM Assistant' },
    content:
      'Guia detalhado sobre como gerenciar e organizar perfis de clientes para melhor gerenciamento de relacionamento.',
    created_at: 1736143274,
    external_link:
      'https://www.cortex.jarbis.com/hc/user-guide/articles/1677688210-managing-customer-profiles',
    id: 3061,
    name: 'Managing Customer Profiles | User Guide | Cortexwoot',
    status: 'available',
  },
  {
    account_id: 4,
    assistant: { id: 4, name: 'SalesBot' },
    content:
      'Guia sobre como otimizar o rastreamento de vendas e aprimorar a previsão de vendas usando recursos avançados.',
    created_at: 1736143275,
    external_link:
      'https://www.cortex.jarbis.com/hc/user-guide/articles/1677688220-sales-tracking-guide',
    id: 3062,
    name: 'Sales Tracking Guide | User Guide | Cortexwoot',
    status: 'available',
  },
  {
    account_id: 5,
    assistant: { id: 5, name: 'TicketBot' },
    content:
      'Guia sobre como gerenciar e resolver tickets de forma eficiente no Cortexwoot.',
    created_at: 1736143276,
    external_link:
      'https://www.cortex.jarbis.com/hc/user-guide/articles/1677688230-managing-tickets',
    id: 3063,
    name: 'Managing Tickets | User Guide | Cortexwoot',
    status: 'available',
  },
  {
    account_id: 6,
    assistant: { id: 6, name: 'Finance Wizard' },
    content:
      'Guia detalhado sobre como usar ferramentas de relatórios financeiros e gerar análises valiosas.',
    created_at: 1736143277,
    external_link:
      'https://www.cortex.jarbis.com/hc/user-guide/articles/1677688240-financial-reporting',
    id: 3064,
    name: 'Financial Reporting | User Guide | Cortexwoot',
    status: 'available',
  },
];

export const responsesList = [
  {
    account_id: 1,
    answer:
      'O Messenger pode ser desativado porque você está em um plano gratuito ou o limite de caixas de entrada foi atingido.',
    created_at: 1736283330,
    id: 87,
    question: 'Por que o Messenger no Cortexwoot está desativado?',
    status: 'pending',
    assistant: {
      account_id: 1,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033280,
      description: 'Assistente geral para consultas gerais e problemas do sistema.',
      id: 1,
      name: 'Assistant 2',
    },
  },
  {
    account_id: 2,
    answer:
      'Para integrar sua conta do WhatsApp, navegue até a seção de Integrações e selecione a opção de integração com o WhatsApp.',
    created_at: 1736283340,
    id: 88,
    question: 'Como integrar o WhatsApp com o Cortexwoot?',
    assistant: {
      account_id: 2,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033281,
      description: 'Assistente geral para integração e configuração relacionadas.',
      id: 2,
      name: 'Assistant 3',
    },
  },
  {
    account_id: 3,
    answer:
      'Para redefinir sua senha, vá para a página de login e clique em "Esqueci a Senha", em seguida, siga as instruções enviadas para seu e-mail.',
    created_at: 1736283350,
    id: 89,
    question: 'Como redefinir a senha no Cortexwoot?',
    assistant: {
      account_id: 3,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033282,
      description: 'Assistente geral para suporte relacionado à conta e recuperação.',
      id: 3,
      name: 'Assistant 4',
    },
  },
  {
    account_id: 4,
    answer:
      'Para habilitar o modo escuro, vá para as configurações, em seguida, navegue até "Aparência" e selecione "Modo Escuro".',
    created_at: 1736283360,
    id: 90,
    question: 'Como habilitar o modo escuro no Cortexwoot?',
    assistant: {
      account_id: 4,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033283,
      description: 'Assistente geral para suporte relacionado à interface e tema.',
      id: 4,
      name: 'Assistant 5',
    },
  },
  {
    account_id: 5,
    answer:
      'Para adicionar um novo membro ao time, vá para as configurações, em seguida, navegue até "Time" e clique em "Adicionar Membro ao Time".',
    created_at: 1736283370,
    id: 91,
    question: 'Como adicionar um novo membro ao time no Cortexwoot?',
    assistant: {
      account_id: 5,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033284,
      description: 'Assistente geral para suporte relacionado ao time e usuários.',
      id: 5,
      name: 'Assistant 6',
    },
  },
  {
    account_id: 6,
    answer:
      'Campanhas no Cortexwoot permitem enviar mensagens direcionadas a segmentos específicos de usuários. Você pode criá-las na seção "Campanhas".',
    created_at: 1736283380,
    id: 92,
    question: 'O que são campanhas no Cortexwoot?',
    assistant: {
      account_id: 6,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033285,
      description:
        'Assistente geral para suporte relacionado à campanhas e mensagens direcionadas.',
      id: 6,
      name: 'Assistant 7',
    },
  },
];

export const inboxes = [
  {
    id: 7,
    name: 'Email Support',
    channel_type: INBOX_TYPES.EMAIL,
    email: 'support@company.com',
  },
  {
    id: 1,
    name: 'Website Chat',
    channel_type: INBOX_TYPES.WEB,
  },
  {
    id: 2,
    name: 'Facebook Support',
    channel_type: INBOX_TYPES.FB,
  },
  {
    id: 5,
    name: 'SMS Service',
    channel_type: INBOX_TYPES.TWILIO,
    messaging_service_sid: 'MGxxxxxx',
  },
  {
    id: 6,
    name: 'WhatsApp Support',
    channel_type: INBOX_TYPES.WHATSAPP,
    phone_number: '+1987654321',
  },
  {
    id: 8,
    name: 'Telegram Support',
    channel_type: INBOX_TYPES.TELEGRAM,
  },
  {
    id: 9,
    name: 'LINE Support',
    channel_type: INBOX_TYPES.LINE,
  },
  {
    id: 10,
    name: 'API Channel',
    channel_type: INBOX_TYPES.API,
  },
  {
    id: 11,
    name: 'SMS Basic',
    channel_type: INBOX_TYPES.SMS,
    phone_number: '+1555555555',
  },
];
